import React from "react"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import MainModel from "./model"

const FormValidations = () => {

  return (
    <>
      <div className="page-content">
          <Breadcrumbs title="Organization" breadcrumbItem="Update Organization Data" />
          <MainModel/>
      </div>
    </>
  )
}

export default FormValidations
